import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useRegisterMutation } from '../store/authApi';
import toast from 'react-hot-toast';
import AuthLayout from './AuthLayout';

const Register: React.FC = () => {
  const [form, setForm] = useState({
    name: '', email: '', password: '', confirmPassword: '', designation: '',
  });
  const [register, { isLoading }] = useRegisterMutation();
  const navigate = useNavigate();

  const update = (key: keyof typeof form, val: string) => setForm(prev => ({ ...prev, [key]: val }));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (form.password !== form.confirmPassword) return toast.error('Passwords do not match');
    if (form.password.length < 6) return toast.error('Password must be at least 6 characters');

    try {
      await register(form).unwrap();
      toast.success('Account created! Please check your email to verify.');
      navigate('/login');
    } catch (error: any) {
      toast.error(error?.data?.message || 'Registration failed');
    }
  };

  const labelCls = "block text-xs font-display font-semibold text-trident-gray-600 uppercase tracking-wider mb-1.5";

  return (
    <AuthLayout isLogin={false}>
      <h2 className="font-display font-extrabold text-3xl text-trident-gray-900 mb-2">Create account</h2>
      <p className="text-trident-gray-500 mb-8">Join the Blog Automation platform in seconds.</p>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className={labelCls}>Full Name</label>
          <input type="text" value={form.name} onChange={(e) => update('name', e.target.value)} className="input-field" placeholder="Jane Doe" required />
        </div>

        <div>
          <label className={labelCls}>Email</label>
          <input type="email" value={form.email} onChange={(e) => update('email', e.target.value)} className="input-field" placeholder="you@example.com" required />
        </div>

        <div>
          <label className={labelCls}>Designation</label>
          <input type="text" value={form.designation} onChange={(e) => update('designation', e.target.value)} className="input-field" placeholder="e.g. QA Engineer" required />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className={labelCls}>Password</label>
            <input type="password" value={form.password} onChange={(e) => update('password', e.target.value)} className="input-field" placeholder="Min 6 characters" required minLength={6} />
          </div>
          <div>
            <label className={labelCls}>Confirm</label>
            <input type="password" value={form.confirmPassword} onChange={(e) => update('confirmPassword', e.target.value)} className="input-field" placeholder="Confirm password" required minLength={6} />
          </div>
        </div>

        <button type="submit" disabled={isLoading} className="btn-primary w-full justify-center flex items-center gap-2 py-3 mt-2">
          {isLoading ? (
            <>
              <svg className="animate-spin" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>
              Creating Account...
            </>
          ) : 'Create Account'}
        </button>
      </form>

      <div className="mt-6 text-center md:hidden">
        <p className="text-sm text-trident-gray-500">
          Already have an account?{' '}
          <Link to="/login" className="font-display font-semibold text-trident-orange hover:underline">Sign in</Link>
        </p>
      </div>
    </AuthLayout>
  );
};

export default Register;
